import styles from "./FAQ.module.scss";
import React, { CSSProperties, useState } from "react";
import { useTranslation } from "react-i18next";

interface IFAQProps {
  title?: string;
  subtitle?: string;
  backgroundColor?: CSSProperties["backgroundColor"];
  faqs: { question: string; answer: string | string[] }[];
}

const FAQ: React.FC<IFAQProps> = ({ title, subtitle, backgroundColor, faqs }) => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className={styles.faqContainer}
      style={backgroundColor ? { backgroundColor } : { backgroundColor: "#FFF" }}
    >
      <div className={"container"}>
        <h2 className={styles.title}>{title ? title : t("FrequentlyAskedQuestions")}</h2>
        <div className={styles.wrapper}>
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`${styles.faqItem} ${openIndex === index ? styles.open : ""}`}
            >
              <button className={styles.question} onClick={() => toggleFAQ(index)}>
                {faq.question}
                <span className={styles.icon}></span>
              </button>
              <div className={styles.answer}>
                {typeof faq.answer === "string" ? (
                  <p>{faq.answer}</p>
                ) : (
                  <ul>
                    {faq.answer.map((el) => {
                      return <li key={el}>- {el}</li>;
                    })}
                  </ul>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
